import axios from "axios";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
    data() {
        return {
            strutturePresidioTipoAziendaLocaleOptions: [],
            strutturePresidioTipoAziendaLocalePathResource: "/strutturepresiditipoaziendalocale",
            pathResourcePresidioPrestazioni: "/ricettaprestazionipresidio"
        };
    },
    methods: {
        loadDataStrutturePresidioTipoAzienda() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidioPrestazioni;
            axios.get(link)
                .then((response) => {
                    this.strutturePresidioTipoAziendaLocaleOptions = response.data.data.list;
                })
                .catch((error) => {
                    this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        loadPrestazioniPresidioByCodicePresidio(codicePresidio, callback) {
            let link = process.env.VUE_APP_PATH_API + "/ricettaprestazionipresidio";
            axios.get(link, { params: { codicePresidio: codicePresidio } })
                .then((response) => {
                    callback(response)
                })
                .catch((error) => {
                    error;
                    toast.error("Errore nel recupero dati");
                });
        }
    },
};
